module.exports = __webpack_public_path__ + "static/media/FavouriteCircular.c1fc6f45.svg";